export const urls = {
  home: '/',
  netSuiteSynchronisationInformation: '/netsuite-synchronisation-information',
  documentList: '/documents',
};
